import {createSelector} from 'reselect';
import {getGroupedOptionsFromTreeByPredicate} from '../../utils/tree-helpers';

export const getIssueRootCausesDefinitionsEntitiesMap = state => state.issueRootCauses.definitions.entitiesMap;
export const getIssueRootCausesCategoriesIds = state => state.issueRootCauses.definitions.issueRootCauseCategoriesIds;
export const isErrorLoadingIssueRootCausesDefinitions = state => state.issueRootCauses.definitions.error;
export const isLoadingIssueRootCausesDefinitions = state => state.issueRootCauses.definitions.loading;
export const isIssueRootCausesDefinitionsFetched = state => state.issueRootCauses.definitions.fetched;
export const isCreatingRootCausesAdmin = state => state.issueRootCauses.definitions.isCreating;
export const currentTitleEditedRootCauseId = state => state.issueRootCauses.definitions.currentTitleEditedRootCauseId;
export const isDeletingRootCausesAdmin = state => state.issueRootCauses.definitions.isDeleting;
export const showRootCauseCategoryInUseModal = state =>
  state.issueRootCauses.definitions.showRootCauseCategoryInUseModal;
export const showRootCauseInUseModal = state => state.issueRootCauses.definitions.showRootCauseInUseModal;

export const getActiveIssueRootCausesGroupedDropdownOptions = createSelector(
  getIssueRootCausesDefinitionsEntitiesMap,
  getIssueRootCausesCategoriesIds,
  (entitiesMap, issueRootCauseCategoriesIds) => {
    const activeGroupedOptions = [];
    issueRootCauseCategoriesIds.forEach(issueRootCauseIds => {
      const category = entitiesMap[issueRootCauseIds];
      if (category.isActive) {
        const childrenIds = category.childrenIds;
        if (childrenIds) {
          const activeRootCauses = childrenIds
            .map(rootCauseId => entitiesMap[rootCauseId])
            .filter(rootCause => rootCause.isActive);
          if (activeRootCauses.length) {
            activeGroupedOptions.push([category.title, activeRootCauses]);
          }
        }
      }
    });
    return activeGroupedOptions;
  }
);

export const getActiveIssueRootCausesGroupedDropdownOptionsIncludingCurrent = createSelector(
  getIssueRootCausesDefinitionsEntitiesMap,
  getIssueRootCausesCategoriesIds,
  (_, selectedOptionId) => selectedOptionId,
  (entitiesMap, issueRootCauseCategoriesIds, selectedOptionId) => {
    const selectedRootCause = entitiesMap[selectedOptionId];
    const issueRootCauseCategories = issueRootCauseCategoriesIds.map(id => entitiesMap[id]);
    const isActiveOrSelected = rootCauseOrCategory =>
      rootCauseOrCategory.isActive ||
      rootCauseOrCategory.id === selectedRootCause.id ||
      rootCauseOrCategory.id === selectedRootCause.parentId;

    return getGroupedOptionsFromTreeByPredicate(issueRootCauseCategories, isActiveOrSelected, entitiesMap);
  }
);

export const getIssueRootCauseCategoryById = createSelector(
  getIssueRootCausesDefinitionsEntitiesMap,
  (state, id) => id,
  (entitiesMap, id) => entitiesMap[id]
);

export const getIssueRootCauseCategoryNames = createSelector(
  getIssueRootCausesDefinitionsEntitiesMap,
  getIssueRootCausesCategoriesIds,
  (entitiesMap, issueRootCauseCategoriesIds) =>
    issueRootCauseCategoriesIds.map(id => entitiesMap[id].title.toLowerCase())
);

export const getIssueRootCausesNames = createSelector(
  getIssueRootCausesDefinitionsEntitiesMap,
  (state, childrenIds) => childrenIds,
  (entitiesMap, childrenIds) => (childrenIds ? childrenIds.map(id => entitiesMap[id].title.toLowerCase()) : [])
);
